import {useIsMobile} from '../util/mobile';
import MainNav from './MainNav';
import {Box} from '@sproutsocial/racine';
import {Outlet} from 'react-router';

const AppShell = () => {
	const isMobile = useIsMobile();

	return (
		<Box
			as='main'
			display='flex'
			height='100%'
			overflow='hidden'
			flexDirection={isMobile ? 'column' : 'initial'}
		>
			<MainNav />
			<Box flex={1} overflow='hidden auto'>
				<Outlet />
			</Box>
		</Box>
	);
};

export default AppShell;
